/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Components_Videoplayer_Title1Inputs */

const id_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const ms_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const da_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const de_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const en_us2_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const es_es2_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const es_mx2_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const fil_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const fr_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const it_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const hu_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const nl_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const no_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const pl_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const pt_br2_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const pt_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const ro_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const fi_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const sv_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const vi_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const tr_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const cs_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const bg_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const ru_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const uk_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const ar_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const hi_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const th_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const ja_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const zh_cn2_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const zh_hant1_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const ko_components_videoplayer_title1 = /** @type {(inputs: Components_Videoplayer_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

/**
* | output |
* | --- |
* | "{title}" |
*
* @param {Components_Videoplayer_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_videoplayer_title1 = /** @type {((inputs: Components_Videoplayer_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Videoplayer_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_videoplayer_title1(inputs)
	if (locale === "ms") return ms_components_videoplayer_title1(inputs)
	if (locale === "da") return da_components_videoplayer_title1(inputs)
	if (locale === "de") return de_components_videoplayer_title1(inputs)
	if (locale === "en-US") return en_us2_components_videoplayer_title1(inputs)
	if (locale === "es-ES") return es_es2_components_videoplayer_title1(inputs)
	if (locale === "es-MX") return es_mx2_components_videoplayer_title1(inputs)
	if (locale === "fil") return fil_components_videoplayer_title1(inputs)
	if (locale === "fr") return fr_components_videoplayer_title1(inputs)
	if (locale === "it") return it_components_videoplayer_title1(inputs)
	if (locale === "hu") return hu_components_videoplayer_title1(inputs)
	if (locale === "nl") return nl_components_videoplayer_title1(inputs)
	if (locale === "no") return no_components_videoplayer_title1(inputs)
	if (locale === "pl") return pl_components_videoplayer_title1(inputs)
	if (locale === "pt-BR") return pt_br2_components_videoplayer_title1(inputs)
	if (locale === "pt") return pt_components_videoplayer_title1(inputs)
	if (locale === "ro") return ro_components_videoplayer_title1(inputs)
	if (locale === "fi") return fi_components_videoplayer_title1(inputs)
	if (locale === "sv") return sv_components_videoplayer_title1(inputs)
	if (locale === "vi") return vi_components_videoplayer_title1(inputs)
	if (locale === "tr") return tr_components_videoplayer_title1(inputs)
	if (locale === "cs") return cs_components_videoplayer_title1(inputs)
	if (locale === "bg") return bg_components_videoplayer_title1(inputs)
	if (locale === "ru") return ru_components_videoplayer_title1(inputs)
	if (locale === "uk") return uk_components_videoplayer_title1(inputs)
	if (locale === "ar") return ar_components_videoplayer_title1(inputs)
	if (locale === "hi") return hi_components_videoplayer_title1(inputs)
	if (locale === "th") return th_components_videoplayer_title1(inputs)
	if (locale === "ja") return ja_components_videoplayer_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_videoplayer_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_videoplayer_title1(inputs)
	return ko_components_videoplayer_title1(inputs)
});
export { components_videoplayer_title1 as "components.videoPlayer.title" }